import ProfileMerchant from "@/modules/merchant/components/profileMerchent/ProfileMerchant"
import Layout from "../../layout/main"
/**
 * ProfileMerchantIndex
 *
 * صفحه پروفایل پذیرنده.
 * رندر کامپوننت ProfileMerchant داخل لایه اصلی Layout برای نمایش اطلاعات پروفایل پذیرنده.
 *
 * @returns JSX.Element
 */

export default function ProfileMerchantIndex() {
  return (
    <Layout>
      <ProfileMerchant/>
    </Layout>
  )
}
